/*
 * What a partner is searched in wherever it is picked from a list: its
 * number and the two people its partner relation names — the holder
 * the partnership belongs to and the contact it is reached through.
 * That covers the mail address, the phone number and the postal
 * address of both.
 *
 * The rest of the record stays out on purpose. The anchor of every
 * partner relation is the cooperative, so a search over the whole
 * record would let "Hostsharing" match all of them at once — a deep
 * search is only useful while it searches the entry's own data.
 */
export const partnerSearchRecord = (partner) => ({
  partnerNumber: partner?.partnerNumber,
  holder: partner?.partnerRel?.holder,
  contact: partner?.partnerRel?.contact,
});
